import { Descriptions, Row } from "antd";
import getAtribute from "../../../utils/getAtribute";

export function DetailsComissaoSip3w({ entidade }) {
  if (entidade && !entidade.cpfAutorizadorComissaoSip3w) {
    return <div />;
  }
  const timeFormmatted = entidade.dataAtualizacaoComissaoSip3w
    ? `${new Date(entidade.dataAtualizacaoComissaoSip3w).toLocaleString()}`
    : "";

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Comissão SIP3W</div>
      </Row>
      <br />
      <Descriptions>
        <Descriptions.Item label="Nome">
          {getAtribute(entidade, "nomeAutorizadorComissaoSip3w")}
        </Descriptions.Item>
        <Descriptions.Item label="CPF">
          {getAtribute(entidade, "cpfAutorizadorComissaoSip3w")}
        </Descriptions.Item>
        <Descriptions.Item label="Observação">
          {getAtribute(entidade, "obsComissaoSip3w")}
        </Descriptions.Item>
        <Descriptions.Item label="Data">{timeFormmatted}</Descriptions.Item>
      </Descriptions>
    </>
  );
}
